document.addEventListener('DOMContentLoaded', () => {
  const slideshows = document.querySelectorAll('ca-slideshow-component');

  slideshows.forEach(slideshow => {
    const slider = slideshow.querySelector('.ca-slideshow');
    const slides = slider.querySelectorAll('.ca-slide');
    const prevButton = slideshow.querySelector('.ca-slider-button--prev');
    const nextButton = slideshow.querySelector('.ca-slider-button--next');
    const autoplayButton = slideshow.querySelector('.ca-slideshow__autoplay');
    const speed = parseInt(slideshow.dataset.speed) * 1000 || 5000;
    const autoRotate = slideshow.dataset.autoplay === 'true';
    const randomAnimation = slideshow.dataset.randomAnimation === 'true';
    let currentSlide = 0;
    let intervalId = null;

    const animationOptions = [
      'ca-slide-3d-rotate',
      'ca-slide-3d-flip',
      'ca-slide-3d-depth',
      'ca-slide-3d-galaxy'
    ];

    function getAnimationClass() {
      if (randomAnimation) {
        const randomIndex = Math.floor(Math.random() * animationOptions.length);
        return animationOptions[randomIndex];
      }
      return slideshow.classList.contains('none') ? '' : slideshow.classList.value.match(/slide-3d-[a-z-]+/)?.[0] || '';
    }

function updateSlide(index) {
  slides.forEach((slide, i) => {
    slide.classList.remove('active');
    slide.classList.remove(...animationOptions);
    if (i === index) {
      const animationClass = getAnimationClass();
      if (animationClass) slide.classList.add(animationClass);
      slide.classList.add('active');
      if (i === 0 || slide.classList.contains('active')) {
        slide.querySelector('img').setAttribute('loading', 'eager');
      } else {
        slide.querySelector('img').setAttribute('loading', 'lazy');
      }
    }
  });
  currentSlide = index;
  updateCounter();
}

    function nextSlide() {
      const newIndex = (currentSlide + 1) % slides.length;
      updateSlide(newIndex);
    }

    function prevSlide() {
      const newIndex = (currentSlide - 1 + slides.length) % slides.length;
      updateSlide(newIndex);
    }

    function toggleAutoplay() {
      if (autoRotate) {
        autoplayButton.classList.toggle('ca-slideshow__autoplay--paused');
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        } else {
          intervalId = setInterval(nextSlide, speed);
        }
      }
    }

    function updateCounter() {
      const counterCurrent = slideshow.querySelector('.ca-slider-counter--current');
      const counterTotal = slideshow.querySelector('.ca-slider-counter--total');
      if (counterCurrent && counterTotal) {
        counterCurrent.textContent = currentSlide + 1;
      }
    }

    // Inizializza il primo slide
    updateSlide(currentSlide);

    // Aggiungi event listener
    if (prevButton) prevButton.addEventListener('click', prevSlide);
    if (nextButton) nextButton.addEventListener('click', nextSlide);
    if (autoplayButton) autoplayButton.addEventListener('click', toggleAutoplay);

    // Avvia autoplay se abilitato
    if (autoRotate) {
      intervalId = setInterval(nextSlide, speed);
    }
  });
});